export default __webpack_public_path__ + "assets/f9f832b0ed3f1ab138c962ada983dbcc.ttf";